import React, {PropTypes} from 'react';
import {displayDateFormat} from 'app/lib/format';
import moment from 'moment';
import {Select, Input, Button, Row, Col, Toast, FreeTextSelect, Icon} from 'routes/app/components';
import ButtonGroup from 'routes/app/components/ButtonGroup';
import {FormattedMessage} from 'react-intl';
import './style.scss';

const VisitFilterForm = ({
    highlight, onClickFilter, expanded, licensePlates, statuses, terminals, transCompList,
    fields:{lp, status, dom, trac, tc, vn, from, to}, onSubmit, resetForm, formatMessage
}) => {

    return (
        <div className="visits__filter">
            <Row className={highlight ? 'visits__filter__highlight' : ''}>
                <Button onClick={onClickFilter} className="btn-no-active" flat><FormattedMessage id="filter.toggle" />
                    {expanded ? <Icon className="right">keyboard_arrow_up</Icon> : <Icon className="right">keyboard_arrow_down</Icon>}
                </Button>
            </Row>
            {expanded &&
            <form onSubmit={onSubmit}>
                <Row>
                    {terminals.length > 1 &&
                    <Select s={12} m={6} id="dom" label={<FormattedMessage id="visit.terminal" />}
                            options={terminals} optionValue="code" optionLabel="name"
                        {...dom}
                    />
                    }

                    <Input s={12} m={3} type="date" label={<FormattedMessage id="visit.dateFrom" />}
                           placeholder={formatMessage({id:'input.help.date'})}
                           format={displayDateFormat}
                        {...from}
                           onChange={(value) => {

                                let toDate = moment(to.value, displayDateFormat);
                                let fromDate = moment(value, displayDateFormat);
                                if (toDate < fromDate) {
                                    to.onChange(value);
                                }
                                from.onChange(value);
                           }}
                    />

                    <Input s={12} m={3} type="date" label={<FormattedMessage id="visit.dateTo" />}
                           placeholder={formatMessage({id:'input.help.date'})}
                           format={displayDateFormat}
                           datePickerOptions={{min: from.value && new Date(moment(from.value, displayDateFormat).format('x'))}}
                        {...to}
                           onChange={(value) => {
                                let toDate = moment(value, displayDateFormat);
                                let fromDate = moment(from.value, displayDateFormat);
                                value = toDate < fromDate ? from.value : value;
                                to.onChange(value);
                           }}
                    />

                    <Input s={6} m={3} label={<FormattedMessage id="visit.trac" />} {...trac} />
                    <Input s={6} m={3} label={<FormattedMessage id="visit.number" />} {...vn} />

                    {transCompList.length > 1 &&
                    <Select s={12} m={6} id="tc" label={<FormattedMessage id="visit.transName" />}
                            options={transCompList} optionValue="code" optionLabel="name"
                        {...tc}
                    />
                    }

                    {licensePlates.length ?
                        <FreeTextSelect s={6} m={3}
                                        id="licensePlate" label={<FormattedMessage id="visit.licenseplate" />}
                                        options={licensePlates}
                            {...lp}/>
                        :
                        <Input s={6} m={3} id="licensePlate"
                               label={<FormattedMessage id="visit.licenseplate" />} {...lp}
                               value={lp.value ? lp.value.trim() : null}/>
                    }
                    <Select s={6} m={3}
                            name="status" label={<FormattedMessage id="visit.status" />}
                            options={statuses} optionValue="code" optionLabel="display"
                        {...status}
                    />

                </Row>
                <Row>
                    <Col s={12}>
                        <div className="visits__filter__submit">
                            <ButtonGroup>
                                <Button><FormattedMessage id="filter.submit"/></Button>
                                <Button onClick={(e)=>{e.preventDefault(); resetForm();}} flat><FormattedMessage id="filter.reset"/></Button>
                            </ButtonGroup>
                        </div>
                    </Col>
                </Row>
            </form>
            }
        </div>
    );
};

VisitFilterForm.propTypes = {
    onClickFilter: PropTypes.func.isRequired,
    expanded: PropTypes.bool.isRequired,
    fields: PropTypes.object.isRequired,
    licensePlates: PropTypes.array,
    transCompList: PropTypes.array,
    statuses: PropTypes.array,
    terminals: PropTypes.array,
    onSubmit: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    highlight: PropTypes.bool
};

export default VisitFilterForm;